import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@core/services/auth.service';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [],
  template: `
    <div class="fixed inset-0 flex items-center justify-center bg-white bg-opacity-0 z-50"></div>
  `,
})
export class AuthComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthenticationService);

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code')?? '';
    const state = this.route.snapshot.queryParamMap.get('state')?? '';

    if(!state && !code) return this.authService.initiateUL();
    if(!this.authService.isValidState(state)) {
      this.authService.resetState();
      throw new Error('Invalid state.')
    }
    this.authService.login(code);
  }
}
